<div class="signup-template-wrapper" *ngIf="combinedData$ | async as combinedData">
  <!-- Enhanced Header Section -->
  <div class="template-header">
    <div class="header-content">
      <h1 class="template-title">Signup Templates</h1>
      <p class="template-description">
        <code>Signup Templates</code> control how sign ups to events are processed.
        They define the emojis, the sign up behavior and sign up limits. 
        <a href="https://docs.raidorganizer.org/signup-templates/" target="_blank" class="docs-link">Read more about them here</a>.
      </p>
    </div>
  </div>

  <a *ngIf="creatingNew" class="community-banner" routerLink="/templates">
    <span class="community-banner__icon" aria-hidden="true">
      <mat-icon>explore</mat-icon>
    </span>
    <span class="community-banner__copy">
      <span class="community-banner__title">Browse community templates</span>
      <span class="community-banner__text">
        Other servers have shared signup templates you can import into this server, instead of building one from scratch.
      </span>
    </span>
    <span class="community-banner__action">
      Browse catalogue
      <mat-icon aria-hidden="true">arrow_forward</mat-icon>
    </span>
  </a>

  <!-- Main Content Grid -->
  <div class="row g-4">
    <!-- Settings Column -->
    <div class="col-12 col-xxl settings-column">
      <div class="section-header">
        <h2 class="section-title">Settings</h2>
        <mat-icon class="section-icon">settings</mat-icon>
      </div>
      <app-signup-template-builder 
        [serverCustomEmojis]="combinedData.customEmojis" 
        [signupTemplate]="combinedData.signupTemplateInfo">
      </app-signup-template-builder>
    </div>

    <!-- Divider -->
    <div class="col-auto d-none d-xxl-flex align-items-stretch px-0">
      <div class="content-divider"></div>
    </div>

    <!-- Preview Column -->
    <div class="col-12 col-xxl-auto preview-column">
      <div class="section-header">
        <h2 class="section-title">Preview</h2>
        <mat-icon class="section-icon">visibility</mat-icon>
      </div>
      <div class="preview-container">
        <app-embed-preview></app-embed-preview>
      </div>
    </div>
  </div>
</div>
